import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { UploadFiscalDocumentsValidationSchema } from "../schemas/uploadFiscalDocuments.schema";

interface UseUploadFiscalDocumentForConsumption {
  id: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

const useBillingEventUploadFiscalDocumentForConsumption = ({ id, onSuccess, onError }: UseUploadFiscalDocumentForConsumption) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['billingEventUploadFiscalDocument'],
    mutationFn: async (files: UploadFiscalDocumentsValidationSchema['fiscal_documents']) => {
      return await privateAxios.put(`/billing/events/${id}/upload_fiscal_document_for_consumption`, {
        event: {
          eventable: {
            fiscal_documents_blobs: files.map((document) => document.id)
          },
        }
      });
    },
    onSuccess,
    onError,
  });
};

export default useBillingEventUploadFiscalDocumentForConsumption;
